import { IamPort } from './ProfileViewModel'
import Member from 'iam/models/Member'
import Skill from 'iam/models/Skill'
import { computed, makeObservable } from 'mobx'
import { SelectionViewModelPort } from './SelectionViewModel'
import { AlertFactory } from 'alerts/Alert'
import { CursorPaged, CursorPageQuery, Id } from 'types/definitions'

const skillSorter = (a: Skill, b: Skill) => {
  const aName = a.name.toLowerCase()
  const bName = b.name.toLowerCase()
  if (aName > bName) return 1
  if (aName < bName) return -1
  return 0
}

export default class SkillsSelectionViewModelAdapter
  implements SelectionViewModelPort<Skill>
{
  constructor(
    public newAlert: AlertFactory,
    private member: Member,
    private iamPort: IamPort,
  ) {
    makeObservable(this)
  }

  getItemId(item: Skill): string {
    return Id.assert(item.id)
  }

  @computed
  get selection(): Skill[] {
    return this.member.skills.slice().sort(skillSorter)
  }

  async fetch(query: CursorPageQuery): Promise<CursorPaged<Skill>> {
    return this.iamPort.fetchSkills(this.member.workspace, query)
  }

  add(item: Skill): Promise<unknown> {
    return this.iamPort.addSkill(this.member, item)
  }

  remove(item: Skill): Promise<unknown> {
    return this.iamPort.removeSkill(this.member, item)
  }

  getTextSearchValues(item: Skill) {
    return [item.name, item.description]
  }

  canUpdate() {
    return true
  }
}
